<template>
  <div class="initial-wrap">
    <span
      v-for="al in alphabet"
      :key="al.str"
      v-on:click="move(al.str)"
      :class="isActive(al.str) ? 'active initial' : 'initial'"
    >
      {{ al.str.toUpperCase() }}
    </span><span v-on:click="move('number')" :class="isActive('number') ? 'active initial' : 'initial'">数字</span>
  </div>
</template>

<script>
  const querystring = require('querystring')

  export default {
    data () {
      return {
        alphabet: [
          { str: 'a' },
          { str: 'b' },
          { str: 'c' },
          { str: 'd' },
          { str: 'e' },
          { str: 'f' },
          { str: 'g' },
          { str: 'h' },
          { str: 'i' },
          { str: 'j' },
          { str: 'k' },
          { str: 'l' },
          { str: 'm' },
          { str: 'n' },
          { str: 'o' },
          { str: 'p' },
          { str: 'q' },
          { str: 'r' },
          { str: 's' },
          { str: 't' },
          { str: 'u' },
          { str: 'v' },
          { str: 'w' },
          { str: 'x' },
          { str: 'y' },
          { str: 'z' }
        ],
        searchCategory: '',
        current: ''
      }
    },

    methods: {
      isActive (initial) {
        if (initial === this.current) {
          return true;
        }

        return false;
      },

      move (str) {
        if (this.isActive(str)) {
          var url = '/fintechs';

          if (this.searchCategory) {
            url = url + '?category=' + this.searchCategory;
          }
        } else {
          var url = '/fintechs?initial=' + str;

          if (this.searchCategory) {
            url = url + '&category=' + this.searchCategory;
          }
        }

        location.href = url;
        return false;
      }
    },

    mounted () {
      if (location.search) {
        const search = location.search.replace('?', '')
        this.searchCategory = querystring.parse(search).category
        this.current = querystring.parse(search).initial
      }
    }
  };
</script>

<style lang="scss">
  @import '../../sass/variables';

  .initial {
    color: white !important;
    cursor: pointer;
    margin-right: 5px;
    padding: 0px 10px;
    background: cBaseDk(40);
    margin-bottom: 5px;
    font-family: $font-family-sans-serif;
    text-align: center;
    display: inline-block;
    &.active{
      background: $cKey;
    }
  }

  .initial-wrap {
    margin: 10px 0px;
  }
</style>
